import { Form } from "antd";
import AddIcon from "../../../../../assets/icons/AddIcon";
import { TemplateStepProps } from "../../../../../types/template.types";
import RequiredField from "./RequiredField";

const RequiredFields = ({ form }: TemplateStepProps) => {
  return (
    <Form
      layout="vertical"
      form={form}
      initialValues={{ required_fields: [{}] }}
    >
      <Form.List name="required_fields">
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => (
              <RequiredField
                key={index}
                field={field}
                length={fields?.length}
                namePrefix={["required_fields", field.name]}
                handleRemoveField={() => remove(field.name)}
                form={form}
              />
            ))}

            <div
              className="text-[#FE7235] flex items-center gap-2 cursor-pointer mt-4"
              onClick={() => add({})}
            >
              <span>
                <AddIcon />
              </span>
              <span>Add New Field</span>
            </div>
          </>
        )}
      </Form.List>
    </Form>
  );
};

export default RequiredFields;
